const baseStyle = {
  borderWidth: '2px',
  borderColor: 'slate.100',
};

const variantSolid = {
  borderStyle: 'solid',
};

const variantDashed = {
  borderStyle: 'dashed',
};

const variants = {
  solid: variantSolid,
  dashed: variantDashed,
};

const defaultProps = {
  variant: 'solid',
};

export const Divider = {
  baseStyle,
  variants,
  defaultProps,
};
